export default __webpack_public_path__ + "static/media/icon-favourite-unclick.c91228c5.svg";